<template>
	<div class="table-responsive">
		<!-- Web Version -->
		<table class="table table-hover hide-on-mobile">
			<slot name="columnHeader"></slot>
			<tbody>
				<tr v-for="(data, i) in dataTable.data" :key="i">
					<td>{{ (dataTable.current_page - 1) * dataTable.per_page + i + 1 }}</td>
					<td v-for="(column, ckey) in columns" :key="ckey">
						<div v-if="column == 'created_at'">
							{{data[column] | moment("DD-MM-yyyy") }}<br>
							{{data[column] | moment("HH:mm") }} WIB
						</div>
						<div v-if="column == 'col_status'">
							<button class="info" :class="
								data[column] == 'Dalam Proses' ? 'warning' :
								data[column] == 'Menunggu Pickup' ? 'wait' :
								data[column] == 'Pickup Driver' ? 'pickup' :
								data[column] == 'Dalam Pengiriman' ? 'infoo' :
								data[column] == 'Selesai Diterima' ? 'success' :
								'warning'
							">{{ data[column] }}</button>
						</div>
						<div v-else-if="column == 'price'">
							{{data[column] | currency}} /kg
						</div>
						<div v-else-if="column == 'price_box'">
							{{data[column] | currency}} /Box
						</div>
						<div v-else-if="column == 'total_volume'">
							{{data[column] | decimal}} m3
						</div>
						<div v-else-if="column == 'total_berat'">
							{{data[column] | decimal}} kg
						</div>
						<div v-else v-html="column == 'created_at' ? '' : data[column]"></div>
					</td>
					<td>
						<ActionEditDelete v-if="action == 'action-edit-delete'"
							:target="`/${page}/${data.id}/edit`"
							:selectedId="data.id"
							@deletedId="deletedId"
							:targetModal="targetModal" />

						<ActionEditDeleteDetail v-if="action == 'action-edit-delete-detail'"
							:target="`/${page}/${data.id}/edit`"
							:selectedId="data.id"
							:data="data"
							@deletedId="deletedId"
							:targetModal="targetModal" />

						<ActionCancelPrintDetail v-if="action == 'action-cancel-print-detail'"
							:target="`/${page}/${data.id}/detail`"
							:targetprint=" $route.name == 'DeliveryIndex' ? `/${page}/print?no_resi=${data.no_resi}` : `/${page}/print?id=${data.id}` "
							:selectedId="data.id"
							:data="data"
							@cancelId="cancelId"
							:targetModalCancel="targetModalCancel" />
					</td>
				</tr>
			</tbody>
		</table>

		<!-- Mobile Version -->
		<div class="hide-on-web">			
			<div class="colee" v-for="(data, i) in dataTable.data" :key="i">
				<div class="row">										
					<div class="flex-column">
						<p class="title-colee">No</p>
						<p>{{ (dataTable.current_page - 1) * dataTable.per_page + i + 1 }}</p>
						<div v-for="(column, ckey) in columns" :key="ckey">
							<p class="title-colee">{{head[ckey+1]}}</p>
							<p v-if="column == 'created_at'">
								{{data[column] | moment("DD-MM-yyyy") }} {{data[column] | moment("HH:mm") }} WIB
							</p>
							<p v-if="column == 'col_status'">
								<button class="info" :class="
									data[column] == 'Dalam Proses' ? 'warning' :
									data[column] == 'Menunggu Pickup' ? 'wait' :
									data[column] == 'Pickup Driver' ? 'pickup' :
									data[column] == 'Dalam Pengiriman' ? 'infoo' :
									data[column] == 'Selesai Diterima' ? 'success' :
									'warning'
								">{{ data[column] }}</button>
							</p>
							<p v-else-if="column == 'price'">
								{{data[column] | currency}} /kg
							</p>
							<p v-else v-html="column == 'created_at' ? '' : data[column]"></p>
						</div>
					</div>
				</div>
				<ActionEditDelete v-if="action == 'action-edit-delete'"
					:target="`/${page}/${data.id}/edit`"
					:selectedId="data.id"
					@deletedId="deletedId"
					:targetModal="targetModal" />

				<ActionEditDeleteDetail v-if="action == 'action-edit-delete-detail'"
					:target="`/${page}/${data.id}/edit`"
					:selectedId="data.id"
					:data="data"
					@deletedId="deletedId"
					:targetModal="targetModal" />

				<ActionCancelPrintDetail v-if="action == 'action-cancel-print-detail'"
					:target="`/${page}/${data.id}/detail`"
					:targetprint=" $route.name == 'DeliveryIndex' ? `/${page}/print?no_resi=${data.no_resi}` : `/${page}/print?id=${data.id}` "
					:selectedId="data.id"
					:data="data"
					@cancelId="cancelId"
					:targetModalCancel="targetModalCancel" />
			</div>
		</div>
		
		<Pagination :data="dataTable"/>

		<ModalDelete 
			:urlDelete="urlDelete"
			:modalDeleteId="modalDeleteId"
			:targetModal="targetModal"/>

		<ModalCancel 
			:urlDelete="urlDelete"
			:modalCancelId="modalCancelId"
			:targetModalCancel="targetModalCancel"/>
	</div>
</template>

<script>
import Pagination from '@/components/table/Pagination'
import ActionEditDelete from '@/components/table/ActionEditDelete'
import ActionEditDeleteDetail from '@/components/table/ActionEditDeleteDetail'
import ActionCancelPrintDetail from '@/components/table/ActionCancelPrintDetail'
import ModalDelete from '@/components/table/ModalDelete'
import ModalCancel from '@/components/table/ModalCancel'

export default {
	name: 'List',
	props: ['dataTable', 'urlDelete', 'page', 'columns', 'action', 'targetModal', 'targetModalCancel', 'head'],
	components: {
		Pagination,
		ActionEditDelete,
		ActionEditDeleteDetail,
		ActionCancelPrintDetail,
		ModalDelete,
		ModalCancel
	},
	data() {
		return {
			modalDeleteId: null,
			modalCancelId: null,
		}
	},
	methods: {
		deletedId(delId) {
			let _ = this
			_.modalDeleteId = delId
		},
		cancelId(canId) {
			let _ = this
			_.modalCancelId = canId
		}
	}	
}
</script>